import axios, { type AxiosResponse } from '@/api/axios';
import { useQuery } from '@tanstack/react-query';
import { Routes, type GetApplicationIndustriesResponse } from '@/api/types';

export const useApplicationIndustries = () => {
  const url = Routes.ApplicationsIndustries;

  return useQuery<GetApplicationIndustriesResponse>({
    queryKey: [url],
    queryFn: async () => {
      const response = await axios.get<
        GetApplicationIndustriesResponse,
        AxiosResponse<GetApplicationIndustriesResponse>
      >(url);
      return response.data;
    },
  });
};
